import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap-theme.min.css';
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker3.min.css';
import 'font-awesome/css/font-awesome.min.css';
import 'awesome-bootstrap-checkbox/awesome-bootstrap-checkbox.css';
import 'lobibox/dist/css/lobibox.min.css';
import '../_dist/public/css/main.css';
import '../_dist/public/css/tree.css';

import 'lobibox/dist/js/notifications.min.js';
import 'highcharts/highstock.js';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js';
import 'bootstrap-datepicker/dist/locales/bootstrap-datepicker.es.min.js';
import 'moment/locale/es-us.js';
import 'moment/locale/br.js';
import 'moment';
import 'lodash/lodash.min.js';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/angular2-router-loader/src!./app/vendor.ts